import { Singleton } from '../../js/Singleton';
import { generalBody } from '../alertBodies';
import SingletonWebSocket from '../Singletons/SingletonWebSocket';
import { SingletonSharedData } from '../singletonSharedData';
import { Logger } from '../../js/helpers/Logger';
import React from 'react';
import {AgentButton} from 'global-components-library';
import { manualCallWindow} from "../../js/draggableComponents";
import { USER_STATE } from '../../constants';
import { errorsMessagePreviewSR } from './Strategies_Preview_RecState';

const language = new Singleton();

export const STRATEGIES_ALERTS = {
  "MANUAL_CALL": function (message,that) {
    var callResult = { dialResult: message.DialResultID };
    let integrationMessage = { client: "galatea", action: "ManualCall", subaction: "onDialResult", data: callResult };
    SingletonWebSocket.send(integrationMessage);
    

    var alertObject = {
      module: message.Module,
      code: message.Code,
      message: message.Message,
      title: "Centerware Kolob",
      btnYes: language.getText("GUIAlertMessageok"),
      body: generalBody(language.getText('alert-' + message.Code)),
      btnNo: message.Code === "1093" ? null : language.getText("CallControlCRMxcontrolscancelButton"),
      onNo: () => { },
      isGlobe: false
    };
    if(that.props.preview.simultaneosRecs){
      let temp= (that.props.preview.records).filter(r=>r.callOutId === message.CallOutId)[0].phoneToCall
      var textBody = errorsMessagePreviewSR(message.Code,temp,true)
      alertObject = {
        module: message.Module,
        code: message.Code,
        message: message.Message,
        title: language.getText('GUIPreviewSimultaneousAlertsresult-notification').replace('(n)',`(${that.props.preview.phoneToCall})`),
        btnYes: language.getText("GUIAlertMessageok"),
        body: textBody ,
        btnNo: message.Code === "1093" ? null : language.getText("CallControlCRMxcontrolscancelButton"),
        onNo: () => { },
        isGlobe: false
      };

    }
    var singletonSharedData = new SingletonSharedData();
    singletonSharedData.problemInManualCall = true;
    if (message.DialResultID!=1) {
      singletonSharedData.problemInManualCall=false;
    }
    if(singletonSharedData.getDataPreviewPro().dialingMode === 1 && message.DialResultID !== 13)
    {
      ShowSnackBarError(alertObject.body, alertObject.title, that,alertObject.code);
    }
    if(message.Code=="1511"){
      that.props.insertWindow(manualCallWindow(null), false);
    }
    return alertObject;
  },
  "TRANSFER_CALL": function (message) {
    const language = new Singleton();
    var body = language.getText('alert-' + message.AlertCode);
    if(message.AlertCode === "1501")
      body = language.getText('CallControlGUICallTransferno-answer-error');  
    var alertObject = {
      module: "TRANSFER_CALL",
      code: message.AlertCode,
      title: "Centerware Kolob",
      btnYes: language.getText("GUIAlertMessageok"),
      body: body,
      btnNo: language.getText("CallControlCRMxcontrolscancelButton"),
      onNo: () => { },
      isGlobe: false,
      error: {
        Code: message.AlertCode,
        Message: body
      }
    };
    return alertObject;
  }
}

export const STRATEGIES_ALERTS_CODE = {
  "1091": (message, alertObject) => {
    const language = new Singleton();
    alertObject.btnNo = language.getText("CallControlCRMxcontrolscancelButton");
    alertObject.onNo = () => { };
    Logger.Warning("[Strategies_Alerts_And_Errors][STRATEGIES_ALERTS_CODE] Alert code 1091 ", alertObject);
    return alertObject;
  },
  "1093": function (message, alertObject) {
    const language = new Singleton();
    alertObject.btnNo = language.getText("CallControlCRMxcontrolscancelButton");
    alertObject.onNo = () => { };
    return alertObject;
  }
}
export const STRATEGIES_ERRORS = {
  "LOGIN": function (message, that) {
    that.setState({
      consulting: that.state.consulting - 1,
      loginError: message.Code
    });
  }
}

const ShowSnackBarError = (message, title= '',that,code) => {
  let tempTitle = title === '' ? that.language.getText("GUIPreviewdialResult") : title;
  tempTitle = code === '1512' ? '' : tempTitle
  that.props.addToast(message, { 
    title: tempTitle,
    group: 'icon',
    position: 'topRight',  
    icon: 'call-out', 
    iconColor: 'red', 
    color: 'red',
    btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
    timeout: 5000,
  });
}




// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Alerts_And_Errors.js